import { render, staticRenderFns } from "./msNoData.vue?vue&type=template&id=5a9715e4&scoped=true"
import script from "./msNoData.vue?vue&type=script&lang=js"
export * from "./msNoData.vue?vue&type=script&lang=js"
import style0 from "./msNoData.vue?vue&type=style&index=0&id=5a9715e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9715e4",
  null
  
)

export default component.exports